import React, { ChangeEvent, FC } from 'react';
import { Checkbox } from '@atlaskit/checkbox';
import _get from 'lodash/get';

import { ItemHeader, LinkWithRef } from '@/components/primitive';
import { flexStart, spaceGapMinimum } from '@/styles';
import { useFeatureGatesController } from '@/controllers';

import { refineGroups, testIds } from '../constants';
import {
  RefineGroupType,
  RefineOptionType,
  RefineOptionKeyType,
  URLObjectType,
  FilterByTypeType,
} from '../types';
import { helperCopy } from '../copy';

import * as styles from './styles';

type SearchRefinerProps = {
  urlObject: URLObjectType;
  disabledOptions: RefineOptionKeyType[];
  onFilterChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

type CheckboxOptionProps = SearchRefinerProps & { option: RefineOptionType };
const CheckboxOption: FC<CheckboxOptionProps> = ({
  onFilterChange,
  disabledOptions,
  urlObject,
  option,
}) => (
  <Checkbox
    value={option.key}
    label={option.label}
    onChange={onFilterChange}
    name="search-refine-checkbox"
    isChecked={!!urlObject[option.key]}
    isDisabled={disabledOptions.includes(option.key)}
  />
);

const SearchRefiner: FC<SearchRefinerProps> = props => {
  const { allowMimirSLO } = useFeatureGatesController();

  return (
    <div css={styles.searchRefinerStyles}>
      <h4>Refine results</h4>
      <section data-testid={testIds.searchRefiner}>
        {refineGroups.map((refineGroup: RefineGroupType) => (
          <section key={refineGroup.label}>
            <ItemHeader>{refineGroup.label}</ItemHeader>
            <ul>
              {refineGroup.options.map((option: RefineOptionType) => (
                <li key={option.key} css={styles.checkboxLiStyles}>
                  <div css={[flexStart, spaceGapMinimum]}>
                    <CheckboxOption option={option} {...props} />
                    {option.helperCopyPath && _get(helperCopy, option.helperCopyPath)}
                  </div>
                  {option.options?.length &&
                    option.options?.length > 0 &&
                    (option.key !== FilterByTypeType.BySloGroup || allowMimirSLO) && (
                      <ul>
                        {option.options.map((typeOption: RefineOptionType) => (
                          <li key={typeOption.key}>
                            <CheckboxOption option={typeOption} {...props} />
                          </li>
                        ))}
                      </ul>
                    )}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </section>
      <section>
        <LinkWithRef href="/catalog">
          <span>Legacy Search</span>
        </LinkWithRef>
      </section>
    </div>
  );
};

export default SearchRefiner;
